import { render, staticRenderFns } from "./IngressToService.vue?vue&type=template&id=cff48812&"
import script from "./IngressToService.vue?vue&type=script&lang=js&"
export * from "./IngressToService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports